import React, { createContext, useState, useContext, useEffect } from 'react';

// Create context
const ChatContext = createContext();

export const useChat = () => useContext(ChatContext);

export const ChatProvider = ({ children }) => {
  const [isChatVisible, setIsChatVisible] = useState(false);

  useEffect(() => {
console.log({isChatVisible})
  },[])
  // Functions to control chat visibility
  const showChat = () => setIsChatVisible(true);
  const hideChat = () => setIsChatVisible(false);
  const toggleChat = () => setIsChatVisible((prev) => !prev);
  return (
    <ChatContext.Provider value={{ isChatVisible,toggleChat, showChat, hideChat }}>
      {children}
    </ChatContext.Provider>
  );
};

